import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { EncryptStorage } from 'encrypt-storage'

const encryptStorage = new EncryptStorage(import.meta.env.VITE_BLITZ_ENCRYPT_SECRET, {
  prefix: '@blitz',
  stateManagementUse: true
})

const store = createPinia()

store.use(
  createPersistedState({
    storage: encryptStorage
  })
)

export default store
